import { render, staticRenderFns } from "./AppPage.vue?vue&type=template&id=02be3e50&scoped=true&"
import script from "./AppPage.vue?vue&type=script&lang=js&"
export * from "./AppPage.vue?vue&type=script&lang=js&"
import style0 from "./AppPage.vue?vue&type=style&index=0&id=02be3e50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be3e50",
  null
  
)

export default component.exports